import React from 'react';

import {
  DrawerContent as ChakraDrawerContent,
  DrawerContentProps,
  forwardRef,
  useStyleConfig,
} from '@chakra-ui/react';

export const DrawerContent = forwardRef<DrawerContentProps, 'div'>(
  (props, ref) => {
    const styles = useStyleConfig('DrawerContent', { ...props });
    return <ChakraDrawerContent ref={ref} sx={styles} {...props} />;
  }
);
